import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import ConversationStarters from '../ConversationStarters';

const ChatEmptyState = () => (
  <div className="flex-1 flex flex-col items-center justify-center text-center p-8">
    <MessageCircle className="w-16 h-16 text-fnl-pink/40 mb-4" />
    <p className="text-white text-lg font-semibold mb-1">Select a conversation</p>
    <p className="text-purple-300 text-sm">
      Pick a conversation on the left or browse members to start chatting.
    </p>
  </div>
);

const ChatPanel = ({
  partnerId,
  partnerProfile,
  messages,
  currentUserId,
  online,
  input,
  setInput,
  pendingImage,
  setPendingImage,
  onSend,
  endRef,
  partnerTyping,
}) => {
  const [startersDismissed, setStartersDismissed] = useState(false);
  // Show starters only when the conversation is empty (or just one outbound msg)
  // and the user hasn't dismissed them yet for this session.
  const showStarters = !!partnerId && !startersDismissed && messages.length <= 1;

  return (
    <div
      className={`bg-fnl-purple/60 rounded-2xl border border-purple-900/40 flex flex-col overflow-hidden ${
        partnerId ? 'flex' : 'hidden md:flex'
      }`}
    >
      {partnerId ? (
        <>
          <ChatHeader
            partnerId={partnerId}
            partnerProfile={partnerProfile}
            online={online}
            partnerTyping={partnerTyping}
          />
          <MessageList
            messages={messages}
            currentUserId={currentUserId}
            endRef={endRef}
          />
          <ConversationStarters
            visible={showStarters}
            onPick={(text) => setInput(text)}
            onDismiss={() => setStartersDismissed(true)}
          />
          <MessageInput
            input={input}
            setInput={setInput}
            pendingImage={pendingImage}
            setPendingImage={setPendingImage}
            onSend={onSend}
          />
        </>
      ) : (
        <ChatEmptyState />
      )}
    </div>
  );
};

export default ChatPanel;
